import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../../yeffect/StateProvider';
import {connect} from "react-redux";
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {Button} from "@material-ui/core";

const styles = theme => ({
  sectionHeader:{
    position:'absolute',
    top:0,
    left:0,
    backgroundColor:'white',
    width: '100%',
    zIndex: 100,
    paddingTop: '5px',
  },
  tabs:{
    display:'inline-block',
    width:'100%',
    borderBottom:'2px solid #6a94ff',
    marginLeft:0,
    paddingLeft:0,

    '& li':{
      display:'inline-block',

      '& button':{
        margin:'1px',
        padding:'6px 12px',
        backgroundColor:'#383c42',
        color:'white'
      },
      '& button:hover':{
        backgroundColor:'#6a94ff',
      },
      '& button.active':{
        backgroundColor:'#6a94ff',
      }
    }
  },
  flex: {
    flex: 1,
  },
  full:{
    height: 'calc(100% - 15px)'
  },
  information_panel: {
    border:'1px solid #6e6e6e',
    background:'rgba(64,64,64,0.2)',
    margin:'10px',
    padding:'10px'
  }
});

class IssuanceEmail extends Component {
  state={
    activeTab:'usd',
    sent:false,
    langs: [
      ["en","English"],
      ["zh_CN","Simplified Chinese"],
      ["nl","Nederlands"]
    ],
    selectable: [],
    lang:false,
  };

  render() {
    const {classes} = this.props;

    return (
      <Paper style={{position: 'relative', margin: 5}}>
        <AppBar position="static" elevation={0} color={"default"}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.flex}>
              Issuance Email
            </Typography>
          </Toolbar>
        </AppBar>
        <div style={{overflow: 'auto', height: '100%', padding: 5}}>
          <div className={classes.information_panel}>
            Send the completed ISIN to the Requestor Email and entered on the Requestor Tab
          </div>

          <Button variant="contained" color="secondary" onClick={this.props.sendFunction}>Save and Send Issuance Email</Button>
          {(this.state.sent === true) &&
          <i>Email Sent</i>
          }
        </div>
      </Paper>
    )
  }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(IssuanceEmail ))));



// WEBPACK FOOTER //
// ./src/main/content/isinApplications/components/comms_issuance.js